var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportPassed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.6,
    height: 40.573,
    viewBox: "0 0 36.6 40.573",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Icon_metro-security",
    x: 0,
    y: 0,
    width: 36.6,
    height: 40.573,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_51386",
    "data-name": "Group 51386",
    transform: "translate(-904.501 -6084.096)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 904.5, 6084.1)",
    filter: "url(#Icon_metro-security)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-security-2",
    "data-name": "Icon metro-security",
    d: "M15.227,3.856l-8.8,3.911v5.867c0,5.432,3.75,10.5,8.8,11.733,5.05-1.237,8.8-6.3,8.8-11.733V7.767Z",
    transform: "translate(3.07 3.69)",
    fill: "#fff",
    stroke: "#2a7b39",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51230",
    "data-name": "Group 51230"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_5988",
    "data-name": "Line 5988",
    x2: 3,
    y2: 3,
    transform: "translate(919.219 6103.643)",
    fill: "none",
    stroke: "#2a7b39",
    strokeLinecap: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5989",
    "data-name": "Line 5989",
    x1: 4,
    y2: 9,
    transform: "translate(922.219 6097.643)",
    fill: "none",
    stroke: "#2a7b39",
    strokeLinecap: "round",
    strokeWidth: 1.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportPassed);
export default __webpack_public_path__ + "static/media/report-passed.5a928dd13c7589ac0c29b10d314f6a06.svg";
export { ForwardRef as ReactComponent };